export default "__VITE_ASSET__DCuByjAU__"